import addLeadsIcon from "../assets/icons/addLeads.png";
import arrowIcon from "../assets/icons/arrow-rigth.png";
import arrowLeftBlueIcon from "../assets/icons/arrowLeft.png";
import benefitIcon from "../assets/icons/benefit.png";
import checkIconPing from "../assets/icons/check.png";
import checkIcon from "../assets/icons/checked.png";
import checkGreenIcon from "../assets/icons/checkedGreen.png";
import checkListIcon from "../assets/icons/checkList.png";
import checkRoundIcon from "../assets/icons/checkRound.png";
import checkEndIcon from "../assets/icons/chekEnd.png";
import dataAdctionalIcon from "../assets/icons/dataAdctional.svg";
import discretionIcon from "../assets/icons/discretion.png";
import editIcon from "../assets/icons/edit.png";
import editLeadsIcon from "../assets/icons/editLeads.png";
import enterpriseIcon from "../assets/icons/enterprise.png";
import exitIcon from "../assets/icons/exit.png";
import folderIcon from "../assets/icons/folder.png";
import gestaoIcon from "../assets/icons/gesao_de_reserva.png";
import inputAdictionalIcon from "../assets/icons/inputAdictional.png";
import inputBasicIcon from "../assets/icons/inputBasic.png";
import inputProductIcon from "../assets/icons/inputProduct.png";
import inputStatusIcon from "../assets/icons/inputStatus.png";
import leadsIcon from "../assets/icons/leads.png";
import libraryIcon from "../assets/icons/library.png";
import libraryPhotoIcon from "../assets/icons/libraryPhoto.png";
import menuIcon from "../assets/icons/menu.png";
import menuGreyIcon from "../assets/icons/menuGrey.png";
import newPoleIcon from "../assets/icons/newPole.png";
import noteIcon from "../assets/icons/note.png";
import othersContacts from "../assets/icons/othersContacts.svg";
import oportunidadesIcon from "../assets/icons/oportunidadesIcon.svg";
import outlookIcon from "../assets/icons/outlook.png";
import Search from "../assets/icons/Pesquisar.png";
import pinIcon from "../assets/icons/pin.png";
import pingIcon from "../assets/icons/ping.png";
import pingGrenIcon from "../assets/icons/pingGren.png";
import pingGreyIcon from "../assets/icons/pingGrey.png";
import pinMapIcon from "../assets/icons/pinMap.png";
import placeIcon from "../assets/icons/place.png";
import plusGreenIcon from "../assets/icons/plusGrenn.svg";
import poleIcon from "../assets/icons/pole.png";
import polePositionIcon from "../assets/icons/poleposition.png";
import preferenceIcon from "../assets/icons/preference.svg";
import productLeadIcon from "../assets/icons/productLead.png";
import proponentesIcon from "../assets/icons/proponentes.png";
import reservaIcon from "../assets/icons/reserva.png";
import roundeCheckBlueIcon from "../assets/icons/roundeCheckBlue.png";
import roundeUnCheckBlueIcon from "../assets/icons/roundeUncheckBlue.png";
import thermLeadIcon from "../assets/icons/thermLead.png";
import trashIcon from "../assets/icons/trash.svg";
import unCheckIcon from "../assets/icons/unCheck.png";
import unCheckRoundIcon from "../assets/icons/unCheckRound.png";
import unionIcon from "../assets/icons/Union.png";
import userIcon from "../assets/icons/user.png";
import viewIcon from "../assets/icons/view.png";

export default {
  roundeUnCheckBlueIcon,
  roundeCheckBlueIcon,
  preferenceIcon,
  outlookIcon,
  checkListIcon,
  proponentesIcon,
  dataAdctionalIcon,
  productLeadIcon,
  menuGreyIcon,
  pinMapIcon,
  thermLeadIcon,
  unionIcon,
  editLeadsIcon,
  addLeadsIcon,
  iconSearch: Search,
  checkGreenIcon,
  inputBasicIcon,
  inputStatusIcon,
  inputProductIcon,
  inputAdictionalIcon,
  menuIcon,
  leadsIcon,
  viewIcon,
  noteIcon,
  discretionIcon,
  checkEndIcon,
  pinIcon,
  checkIconPing,
  plusGreenIcon,
  trashIcon,
  benefitIcon,
  libraryPhotoIcon,
  folderIcon,
  arrowLeftBlueIcon,
  userIcon,
  placeIco: placeIcon,
  polePositionIcon,
  reservaIcon,
  enterpriseIcon,
  gestaoIcon,
  arrowIcon,
  exitIcon,
  editIcon,
  checkIcon,
  unCheckIcon,
  pingIcon,
  poleIcon,
  newPoleIcon,
  checkRoundIcon,
  unCheckRoundIcon,
  libraryIcon,
  pingGrenIcon,
  pingGreyIcon,
  othersContacts,
  oportunidadesIcon,
};
